import { render, staticRenderFns } from "./userShow.vue?vue&type=template&id=55cb6e72&"
import script from "./userShow.vue?vue&type=script&lang=js&"
export * from "./userShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports